import { render, staticRenderFns } from "./DescargoFinPage.vue?vue&type=template&id=71c4994c"
import script from "./DescargoFinPage.js?vue&type=script&lang=js&external"
export * from "./DescargoFinPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports